import { gql } from "@apollo/client";

import {
  AskAiChatMessageFragment,
  ChatSessionMessageReactionFragment,
} from "./get-ask-ai-session-query";

export default gql`
  ${ChatSessionMessageReactionFragment}
  ${AskAiChatMessageFragment}
  mutation createAskAIMessageMutation(
    $chatSessionId: Int
    $meetingId: Int
    $assessmentId: Int
    $assessmentQuestionId: Int
    $message: String!
    $messageId: String
  ) {
    sendMessageToChatbot(
      chatSessionId: $chatSessionId
      meetingId: $meetingId
      assessmentId: $assessmentId
      assessmentQuestionId: $assessmentQuestionId
      message: $message
      messageId: $messageId
    ) {
      chatSession {
        id
        updated
        reactions {
          edges {
            node {
              ...ChatSessionMessageReactionFragment
            }
          }
        }
        suggestions
        messages {
          edges {
            node {
              ...AskAiChatMessageFragment
            }
          }
        }
      }
    }
  }
`;
